export default "__VITE_ASSET__D65VClk$__"